export default __webpack_public_path__ + "static/media/38.4f6e16a9.png";